export const ADD_SEAT = 'InfoCheckOutReducer/ADD_SEAT';
export const REMOVE_SEAT = 'InfoCheckOutReducer/RM_SEAT';
export const RESET_STATE_CHECKOUT = 'InfoCheckOutReducer/RESET_STATE_CHECKOUT';
export const BOOKING_TICKET_REQUEST = "bookingTicketReducer/BOOKING_TICKET_REQUEST";
export const BOOKING_TICKET_SUCCESS ="bookingTicketReducer/BOOKING_TICKET_SUCCESS";
export const BOOKING_TICKET_FAILED ="bookingTicketReducer/BOOKING_TICKET_FAILED";
export const BOOKING_TICKET_POST ="bookingTicketReducer/BOOKING_TICKET_POST";
export const DAT_VE_POST = 'bookingTicketReducer/DAT_VE_POST';
export const DAT_VE_SUCCESS = 'bookingTicketReducer/DAT_VE_SUCCESS';
export const DAT_VE_FAILED = 'bookingTicketReducer/DAT_VE_FAILED';